import { cn } from "../../lib/utils";
import { Input } from "../ui/input";

/**
 * Input con visualizzazione errore integrata e validazione onBlur
 * 
 * @example
 * // Con validazione onBlur (real-time)
 * <InputWithError
 *   value={form.email}
 *   onChange={(e) => setForm({ ...form, email: e.target.value })}
 *   onValidate={() => validateField('email', form.email)}
 *   error={errors.email}
 *   placeholder="Email"
 * />
 * 
 * // Senza validazione onBlur (solo al submit)
 * <InputWithError
 *   value={form.nome}
 *   onChange={(e) => setForm({ ...form, nome: e.target.value })}
 *   error={errors.nome}
 *   placeholder="Nome"
 * />
 */
export function InputWithError({
  error,
  className,
  onValidate,
  onBlur,
  ...props
}) {
  const handleBlur = (e) => {
    // Esegue la validazione se fornita
    if (onValidate) {
      onValidate();
    }
    // Chiama anche l'onBlur originale se presente
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <div className="space-y-1">
      <Input
        className={cn(
          error && "border-destructive focus-visible:ring-destructive",
          className
        )}
        onBlur={handleBlur}
        {...props}
      />
      {error && (
        <p className="text-xs text-destructive">{error}</p>
      )}
    </div>
  );
}

export default InputWithError;
